import React from 'react';
import { UploadStatusStyle } from './styled';

interface UploadStatusProps {
  status: boolean;
}
const UploadStatus = ({ status }: UploadStatusProps) => {
  const value = status ? '가능' : '불가';

  return <UploadStatusStyle status={status}>{value}</UploadStatusStyle>;
};
export default UploadStatus;
